"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tr = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function Tr(props) {
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "tr", borderBottom: "1px solid rgba(125,125,125,0.1)", _lastOfType: { borderBottom: 'none' } }, props), void 0));
}
exports.Tr = Tr;
//# sourceMappingURL=index.js.map